import { AddCircle } from '@mui/icons-material';
import { IconButton } from '@mui/material';
import React, { createContext, useEffect, useState } from 'react'
import { ModalAgregaPrioridadComponent } from '../../components/prioridades/ModalAgregaPrioridadComponent';
import { ModalEliminarPrioridadComponent } from '../../components/prioridades/ModalEliminarPrioridadComponent';
import { TablaPrioridades } from '../../components/prioridades/TablaPrioridades';
import { TituloComponent } from '../../components/TituloComponent'
import { ObtenerPrioridades } from '../../helpers/AsuntosHelper';

export const PrioridadesContext = createContext();

export const PrioridadesPage = () => {
    const [prioridades, setPrioridades] = useState();
    const [modalAgregaPrioridad, setModalAgregaPrioridad] = useState(false);
    const [modalEliminarPrioridad, setModalEliminarPrioridad] = useState(false);
    const [prioridadSel, setPrioridadSel] = useState();
    const obtenerPrioridades = () => {
        ObtenerPrioridades().then(response => {
            console.log('prioridades en page', response);
            setPrioridades(response);
        })
    }

    useEffect(() => {
        obtenerPrioridades();
    }, [])
    

  return (
    <PrioridadesContext.Provider value={{prioridades, modalAgregaPrioridad, setModalAgregaPrioridad, obtenerPrioridades,modalEliminarPrioridad, setModalEliminarPrioridad,
    prioridadSel, setPrioridadSel}} >
    <div
        style={{
            marginTop:10,
            marginLeft:40
        }}
    >
        <span
          style={{
              display:'flex',
              flexDirection:'row',
              alignItems:'center',
              justifyContent:'space-between',
              maxWidth:'40%'
            }}
        >
            <TituloComponent titulo='Prioridades' />
          <IconButton
            onClick={() => {setPrioridadSel(); setModalAgregaPrioridad(true)}}
          >
            <AddCircle style={{color:'#60318A'}} color="#60318A" />
            Agregar
          </IconButton>
        </span>
    </div>
    <div
        style={{
        fontSize:28,
        fontWeight:'regular',
        marginLeft:10,
        maxWidth:900,
        flex:1,
        backgroundColor:'transparent'
        }}
    >
          <TablaPrioridades prioridades={prioridades} />
    </div>
    <ModalAgregaPrioridadComponent />
    <ModalEliminarPrioridadComponent />
    </PrioridadesContext.Provider>
  )
}
